import styled from "@emotion/styled";
import { Table } from "antd";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { ColumnsType } from "antd/es/table/interface";
import { useEffect, useState } from "react";
import request from "../../../../utils/request";
import { useCallback } from "react";
import styles from "../WisdomPartyBuilding.module.scss";
const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .all {
    padding: 25px 25px;
    text-align: center;
  }

  .title {
    font-size: 50px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #feffff;
    span {
      color: #00eafe;
    }
  }
  .table-box {
    .table-title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #d6fdff;
      margin-bottom: 21px;
    }
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;
type PolicyType = "getProjectList" | "getCompanySubsidy" | "getCompanyList";
export const Policy: React.FC<{
  id?: number | string;
  modelTitle?: string;
  policyType?: PolicyType;
  date?: string;
  placeholder?: string;
  tableCols?: any[];
  onRow?: (record: any) => any;
}> = ({
  id,
  policyType = "getCompanySubsidy",
  date = "2022",
  modelTitle,
  placeholder,
  tableCols,
  onRow,
}) => {
  const [details, setDetails] = useState<Record<string, any>>({});
  const [keys, setKeys] = useState("");
  const [tempKeys, setTempKeys] = useState("");
  const isGetCompanySubsidy = policyType === "getCompanySubsidy";

  const getData = useCallback(() => {
    if (id === undefined) return;
    let url = `/screen/Index/${policyType}`;
    switch (policyType) {
      case "getProjectList": {
        url = `${url}?type=${id}&date=${date}&keys=${keys}`;
        break;
      }
      case "getCompanyList": {
        url = `${url}?type=${id}&keys=${keys}`;
        // url = `${url}?&keys=${keys}`;
        break;
      }
      default: {
        url = `${url}?id=${id}`;
        break;
      }
    }
    request.get(url).then((res) => {
      let temp = {
        subsidy: [],
      };
      switch (policyType) {
        case "getCompanySubsidy": {
          temp = res.data.data;
          break;
        }
        case "getProjectList": {
          temp.subsidy = res.data.data.data;
          break;
        }
        case "getCompanyList": {
          temp.subsidy = res.data.data;
          break;
        }
        default: {
          temp.subsidy = res.data.data;
          break;
        }
      }
      setDetails(temp);
    });
  }, [id, keys, date]);

  useEffect(() => {
    getData();
  }, [getData]);

  const projectColumns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "项目名称",
      align: "center",
      dataIndex: "name",
    },
    {
      title: "总投资（亿元）",
      align: "center",
      dataIndex: "proj_funding",
    },
    {
      title: "长三角项目",
      align: "center",
      dataIndex: "areas",
    },
  ];
  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "收款单位名称",
      align: "center",
      dataIndex: "company",
    },
    {
      title: "金额（元）",
      align: "center",
      dataIndex: "money",
    },
    {
      title: "项目名称",
      align: "center",
      dataIndex: "title",
    },
    {
      title: "付款时间",
      align: "center",
      dataIndex: "stime",
    },
    {
      title: "备注",
      align: "center",
      dataIndex: "desc",
      render(value) {
        return value || "--";
      },
    },
  ];
  const titleMap = new Map();
  titleMap.set(1, "年度签约项目");
  titleMap.set(2, "总投资5亿以上项目数");
  titleMap.set(3, "长三角项目");

  const className = isGetCompanySubsidy ? "box-item table-box" : "table-box";
  const title =
    modelTitle ||
    (isGetCompanySubsidy ? "政策兑现记录" : titleMap.get(id) || "投资项目");
  // const dataSource = isGetCompanySubsidy ? details.subsidy : details;
  const cols = tableCols || (isGetCompanySubsidy ? columns : projectColumns);
  return (
    <Layout>
      {isGetCompanySubsidy && (
        <div className="box-item all">
          <div className="title">
            当前累计兑现金额：<span>{details.total_money}</span>万元
          </div>
        </div>
      )}

      <div className={className}>
        <div className="table-title">{title}</div>
        {!isGetCompanySubsidy && (
          <div
            className={styles.inputWrapper}
            style={{ marginTop: "0px", width: "400px", marginBottom: "20px" }}
          >
            <input
              type="text"
              placeholder={placeholder || "请输入项目名称"}
              value={tempKeys}
              onChange={(e) => {
                // projectName.current = e.target.value;
                setTempKeys(e.target.value);
              }}
            />
            <button
              className={styles.searchBtn}
              onClick={() => {
                //  getEconomys();
                setKeys(tempKeys);
              }}
            >
              搜索
            </button>
          </div>
        )}
        <Table
          columns={cols}
          dataSource={details.subsidy || []}
          scroll={{ y: 520 }}
          style={{ cursor: onRow ? "pointer" : "auto" }}
          onRow={(record) => {
            return onRow?.(record);
          }}
          pagination={false}
          locale={{
            emptyText: "暂无数据",
          }}
        />
      </div>
    </Layout>
  );
};
